<template>
  <div class="el-progress-graph-container">
    <div class="el-progress-graph">
		<div
			class="waiting graph-item"
			:style="waitingStyle"
		/>
		<div 
			class="total graph-item" 
			:style="totalStyle"
		/>
		<div
			class="reserve graph-item"
			:style="reserveStyle"
		/>
		<div
			class="attend graph-item"
			:style="attendStyle"
		/>
		<div
			class="late graph-item"
			:style="lateStyle"
		/>
		<div
			class="late graph-item"
			:style="lateStyle"
		/>
		<div
			class="absense graph-item"
			:style="absenseStyle"
		/>
	</div>
  </div>
</template>

<script>
function calPercent(pie, total) {
	return (pie / total) * 100 + "%";
}

function widthString(pie, total) {
	if (pie === 0) {
		return "0";
	}

	return calPercent(pie, total);
}

export default {
	name: "ElProgressGraph",
	props: ["data"],
	computed: {
		reserveStyle() {
			const TOTAL = this.data.quota + this.data.waiting;
			const PIE = this.data.booking;
			const WIDTH = widthString(PIE, TOTAL);
			return {
				width: WIDTH,
			};
		},
		attendStyle() {
			const TOTAL = this.data.quota + this.data.waiting;
			const PIE = this.data.absence + this.data.late + this.data.attendance;
			const WIDTH = widthString(PIE, TOTAL);
			return {
				width: WIDTH,
			};
		},
		lateStyle() {
			const TOTAL = this.data.quota + this.data.waiting;
			const PIE = this.data.absence + this.data.late;
			const WIDTH = widthString(PIE, TOTAL);
			return {
				width: WIDTH,
			};
		},
		absenseStyle() {
			const TOTAL = this.data.quota + this.data.waiting;
			const PIE = this.data.absence;
			const WIDTH = widthString(PIE, TOTAL);
			return {
				width: WIDTH,
			};
		},
		waitingStyle(){
			const TOTAL = 1;
			const PIE = 1;
			const WIDTH = widthString(PIE, TOTAL);
			const TOTAL_COLOR = '#f2f2f2'
			if(this.data.waiting){
				return {
					width: WIDTH,
				}
			}else{
				return {
					width: WIDTH,
					backgroundColor: TOTAL_COLOR,
				}
			}
		},
		totalStyle() {
			const TOTAL = this.data.waiting + this.data.quota;
			const PIE = this.data.quota;
			const WIDTH = widthString(PIE , TOTAL);
			return {
				width: WIDTH
			}
		}
	},
};
</script>

<style lang="scss">
.el-progress-graph-container {
	width: 100%;
	max-width: 370px;
	margin: 2px auto 0;

	.el-progress-graph {
		position: relative;
		width: 100%;
		height: 12px;
		border-radius: 10px;

		.graph-item {
			position: absolute;
			top: 0;
			left: 0;
			height: 12px;
			border-radius: 10px;
		}

		.absense {
			background-color: #dc1e00;
		}

		.late {
			background-color: #ffe707;
		}

		.reserve {
			background-color: #9b9b9b;
		}

		.attend {
			background-color: #4a4a4a;
		}
		
		.waiting {
			background-color: #d3d3d3;
		}

		.total {
			background-color: #f2f2f2;
		}
	}

	@media screen and (max-width: 768px) {
		width: 170px;
	}
}
</style>
